import { render, staticRenderFns } from "./EduCambridge.vue?vue&type=template&id=1187f62a&scoped=true&"
import script from "./EduCambridge.vue?vue&type=script&lang=js&"
export * from "./EduCambridge.vue?vue&type=script&lang=js&"
import style0 from "./EduCambridge.vue?vue&type=style&index=0&id=1187f62a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1187f62a",
  null
  
)

export default component.exports